<template>
  <el-col :span="24" class="zfMsg-send-wrap">
    <el-form
      :model="FormData"
      label-position="top"
      ref="zfMsgForm"
      class="zfMsgForm"
    >
      <div class="userinfo-input">
        <el-form-item prop="wish_date">
          <div class="input-label">
            <p>选择日期</p>
            <span>(提前一个月登记)</span>
          </div>
          <el-select v-model="FormData.wish_date" placeholder="请选择日期">
            <el-option
              v-for="(item, key) in FormData.wish_date_list"
              :key="key"
              :value="item.wish_date"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
      <div class="userinfo-input">
        <el-form-item prop="wish_type">
          <div class="input-label">
            <p>选择祝福语类型</p>
          </div>
          <el-radio-group
            v-model="FormData.wish_type"
            fill="var(--zfSend-input-text)"
            :border="true"
            class="input-radio-group"
          >
            <el-radio-button
              v-for="(item, key) in FormData.wish_type_list"
              :key="key"
              :value="item"
              :label="item"
            >
              {{ item }}
            </el-radio-button>
          </el-radio-group>
        </el-form-item>
      </div>
      <div class="userinfo-input">
        <el-form-item prop="content">
          <div class="input-label">
            <p>填写祝福语</p>
          </div>
          <el-input
            v-model="FormData.content"
            type="textarea"
            :autosize="{ minRows: 3, maxRows: 4 }"
            maxlength="39"
            show-word-limit
            resize="none"
            placeholder="含标点符号39个字，超出部分另外收费"
          ></el-input>
        </el-form-item>
        <el-text tag="p" class="zfMsg-tishi"
          >本人确认刊登内容无误，并全权委托新民晚报予以刊登，文责自负。</el-text
        >
      </div>
      <div class="userinfo-input">
        <el-form-item prop="realname">
          <el-input
            v-model="FormData.realname"
            placeholder="授权人姓名"
            clearable
          ></el-input>
        </el-form-item>
      </div>
      <div class="userinfo-input">
        <el-form-item prop="phone">
          <el-input
            v-model="FormData.phone"
            placeholder="手机号码"
            maxlength="11"
            clearable
          ></el-input>
        </el-form-item>
      </div>
      <div class="zfMsg-btn">
        <el-button
          type="danger"
          :disabled="canSubmit"
          @click="submitSend"
          class="userInfoSubmit"
          style="width: 60%"
          >提交</el-button
        >
      </div>
    </el-form>
  </el-col>
</template>

<script>
export default {
  name: "ZfSend",
  props: {
    zfMsgForm: Object,
    submitSend: Function,
    canSubmit: Boolean,
  },
  data() {
    return {
      FormData: this.zfMsgForm,
    };
  },
};
</script>

<style scoped>
.userinfo-input {
  border: 0;
  margin-bottom: 10px;
}

.input-radio-group {
  justify-content: space-between;
  width: 100%;
}

.zfMsg-tishi {
  text-align: justify;
  color: var(--zfSend-input-text);
  margin: 10px 0;
}

.zfMsg-btn {
  width: 60%;
  margin: auto;
  padding: 10px 0 20px;
}

.zfMsg-send-wrap {
  margin: auto;
  width: 96%;
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.1);
}
</style>